/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetBracketsMatchesMatchidTimelineQueryResponse,
  GetBracketsMatchesMatchidTimelinePathParams,
} from "../types/GetBracketsMatchesMatchidTimeline.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getBracketsMatchesMatchidTimelineQueryKey = (
  matchId: GetBracketsMatchesMatchidTimelinePathParams["matchId"] | undefined,
) =>
  [
    {
      url: "/brackets/matches/:matchId/timeline",
      params: { matchId: matchId },
    },
  ] as const;

export type GetBracketsMatchesMatchidTimelineQueryKey = ReturnType<
  typeof getBracketsMatchesMatchidTimelineQueryKey
>;

/**
 * @summary Лента событий матча по играм серии. Публичная, как остальные витрины разбора.
 * {@link /brackets/matches/:matchId/timeline}
 */
export async function getBracketsMatchesMatchidTimeline(
  matchId: GetBracketsMatchesMatchidTimelinePathParams["matchId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetBracketsMatchesMatchidTimelineQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/brackets/matches/${matchId}/timeline`,
    ...requestConfig,
  });
  return res;
}

export function getBracketsMatchesMatchidTimelineQueryOptions(
  matchId: GetBracketsMatchesMatchidTimelinePathParams["matchId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getBracketsMatchesMatchidTimelineQueryKey(matchId);
  return queryOptions<
    ResponseConfig<GetBracketsMatchesMatchidTimelineQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetBracketsMatchesMatchidTimelineQueryResponse>,
    typeof queryKey
  >({
    enabled: !!matchId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getBracketsMatchesMatchidTimeline(matchId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Лента событий матча по играм серии. Публичная, как остальные витрины разбора.
 * {@link /brackets/matches/:matchId/timeline}
 */
export function useGetBracketsMatchesMatchidTimeline<
  TData = ResponseConfig<GetBracketsMatchesMatchidTimelineQueryResponse>,
  TQueryData = ResponseConfig<GetBracketsMatchesMatchidTimelineQueryResponse>,
  TQueryKey extends QueryKey = GetBracketsMatchesMatchidTimelineQueryKey,
>(
  matchId: GetBracketsMatchesMatchidTimelinePathParams["matchId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetBracketsMatchesMatchidTimelineQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getBracketsMatchesMatchidTimelineQueryKey(matchId);

  const query = useQuery(
    {
      ...getBracketsMatchesMatchidTimelineQueryOptions(matchId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
